import * as React from 'react'
import { FormattedHTMLMessage } from 'react-intl'

import WaveContainer from '../../components/wave-container'

import DooerLive from '../../sections/dooer-live'
import Engagement from '../../sections/engagement'
import Footer from '../../sections/footer'
import Instagram from '../../sections/instagram'
import Providers from '../../sections/providers'

import Features from './components/features'
import Hero from './components/hero'
import BranchLeading from './components/branch-leading'

import styles from './about.module.scss'
import Seo from '../../components/seo'

export default function Start() {
  return (
    <>
      <Seo
        description="Vi skapar supersmidiga bokföringstjänster, ny typ av realtidsrådgivning och intelligenta företagslösningar. Det ska vara enkelt, kul och lönsamt för dig."
        image="https://www.dooer.com/images/og/og_index.jpg"
        title="Vi moderniserar bokföringssverige | Dooer"
        url="https://www.dooer.com/om-oss"
      />

      <Hero />

      <WaveContainer>
        <Features />
      </WaveContainer>

      <BranchLeading />

      <WaveContainer>
        <Providers className={styles.providers} variant="light" />
      </WaveContainer>

      <Engagement
        description={
          <FormattedHTMLMessage
            defaultMessage={
              "Vi gillar att göra saker tillsammans. Skapa&nbsp;nya funktioner, utveckla nya produkter, fira&nbsp;framgång, testa olika saker&nbsp;och <span class='visible-xs'>inte minst </span>att dela med oss. Ta&nbsp;en&nbsp;titt!"
            }
            id="about.engagement.description"
          />
        }
        title={
          <FormattedHTMLMessage
            defaultMessage={`
              <span class="block-sm">Hos oss händer det massa kul.</span>
              <span class="block-sm">Häng med oss på&nbsp;<a class="{classLink}" href="#dooerlife">#dooerlife</a>. <span class="visible-sm">Och&nbsp;du, följ&nbsp;oss!</span></span>
            `}
            id="about.engagement.title"
            values={{
              classLink: styles.link,
            }}
          />
        }
      />

      <Instagram />
      <DooerLive />
      <Footer inverted />
    </>
  )
}
